import { useState } from "react";
import {
  Box,
  Modal,
  Button,
  Flex,
  Text,
  Logo,
  Icon,
  Image,
} from "@simplybusiness/mobius";
import { cross } from "@simplybusiness/icons";
import { type InterventionProps } from "../../../types";
import { homebuilder } from "../homebuilderImage";

type TradeBasedPopupProps = {
  mainText: string;
  finePrint: string;
} & InterventionProps;

type LogoProps = {
  isMSM: boolean;
};

const WhichLogo = ({ isMSM }: LogoProps) => {
  if (isMSM) {
    return <span className="mobius-interventions__trade-based-msm-logo"></span>;
  }

  return (
    <>
      <Logo className="mobius-interventions__trade-based-logo" />
      <span className="mobius-interventions__trade-based-mobile-logo"></span>
    </>
  );
};

export const TradeBasedPopup = (props: TradeBasedPopupProps) => {
  const [showModal, setShowModal] = useState(true);
  const { mainText, finePrint, fireEvent, site } = props;

  if (!site || !fireEvent) return null;

  const isMSM = site === "moneysupermarket";

  const buildContinueButton = (cssClass: string) => {
    return (
      <Button
        className={cssClass}
        data-testid={cssClass}
        aria-label="Go back to your quote"
        variant="primary"
        size="sm"
        onPress={() => {
          setShowModal(false);
          props.onDismiss?.();
          fireEvent("cta_clicked");
        }}
      >
        Continue your quote
      </Button>
    );
  };

  return (
    <Modal
      className="mobius-interventions__trade-based"
      data-testid="trade-based-claims-modal"
      isOpen={showModal}
    >
      <Modal.Header>
        <WhichLogo isMSM={isMSM} />
        <Button
          className={`mobius-interventions__trade-based-close-button${isMSM ? `-msm` : ""}`}
          variant="ghost"
          size="sm"
          onPress={() => {
            setShowModal(false);
            props.onDismiss?.();
            fireEvent("modal_closed");
          }}
        >
          <Icon icon={cross} /> Close
        </Button>
      </Modal.Header>
      <Modal.Content>
        <Box>
          <Flex
            className="mobius-interventions__trade-based-wrapper"
            rowGap="sm"
          >
            <Flex
              className="mobius-interventions__trade-based-text-flexbox"
              flexDirection="column"
              justifyContent="left"
            >
              <Text
                data-testid="trade-based-claims-text-test-id"
                className={`mobius-interventions__trade-based-text${isMSM ? `-msm` : ""}`}
                elementType="h2"
              >
                {mainText}
              </Text>
              {buildContinueButton(
                "mobius-interventions__trade-based-cta-desktop",
              )}
            </Flex>

            <Image
              src={homebuilder}
              alt=""
              className="mobius-interventions__trade-based-homebuilder"
            />

            {buildContinueButton(
              "mobius-interventions__trade-based-cta-mobile",
            )}
          </Flex>
        </Box>
        <Box>
          <Text
            data-testid="trade-based-claims-disclaimer-test-id"
            className="mobius-interventions__trade-based-text-fineprint"
            elementType="p"
          >
            {" "}
            {finePrint}
          </Text>
        </Box>
      </Modal.Content>
    </Modal>
  );
};
